import React, { useEffect } from 'react';
import { Modal, Button } from '@tencent/tea-component';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@store/index';
import { execCommandCopy, isMobileBrowser } from '@utils/browser';
import { openToast } from '@component/toast';
import { InviteProps } from './Invite.type';
import './Invite.scss';
import { fetchInviteContent } from '@store/meeting/metting.trunk';
import { getInviteContent, getMeetingInfo } from '@store/meeting/meeting.slice';
import { changeIfShowInviteDialog, getIfShowInviteDialog } from '@store/ui/ui.slice';

const Invite: React.FC<InviteProps> = (props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const meeting = useAppSelector(getMeetingInfo);
  const inviteContent = useAppSelector(getInviteContent);
  const ifShowInviteDialog = useAppSelector(getIfShowInviteDialog);

  useEffect(() => {
    dispatch(
      fetchInviteContent({
        meeting_id: meeting.meeting_id,
        sub_meeting_id: '',
        ability: 15,
        is_share_page: 0,
        language: 'en-us',
      }),
    );
  }, []);

  const onInviteClick = () => {
    dispatch(changeIfShowInviteDialog(!ifShowInviteDialog));
  };

  const onCopyClick = () => {
    execCommandCopy(inviteContent);
    openToast(t('复制邀请成功'));
  };
  return (
    <div className={`cpn-invite ${props?.className ?? ''}`} onClick={onInviteClick}>
      <div className="cpn-invite__icon" />
      <div className="cpn-invite__text">{t('邀请')}</div>
      <Modal
        className={`invite-modal ${isMobileBrowser() ? 'invite-modal-phone' : ''}`}
        caption={t('会议邀请')}
        visible={ifShowInviteDialog}
        maskStyle={{ display: 'none' }}
        maskClosable
        onClose={onInviteClick}
      >
        <div>
          <div className="invite-modal__content">{inviteContent || '--'}</div>
          <div className="invite-modal__footer">
            <Button type="primary" onClick={onCopyClick}>
              {t('复制')}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Invite;
